import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildNumericResponseQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const answerText = escapePrintViewText(content.answer || '')
    const rangeText = escapePrintViewText(content.range || '')
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const answerSectionHtml = answerText ? `<p>Answer:</p><p>${answerText}</p>` : ''
    const rangeSectionHtml = rangeText ? `<p>Range:</p><p>${rangeText}</p>` : ''

    return `${questionSectionHtml}${answerSectionHtml}${rangeSectionHtml}`
}

export {buildNumericResponseQuestionPrintView}
